const doc = [({"da":({"js":({"admin":({"highscores":({"organizations":({"search_for_an_organisation_to_add_it":"Søg efter en organisation for at tilføje den"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;